module.exports = __webpack_public_path__ + "static/media/IntroToComputerVision.2e154c85.png";